<template>
  <div class="tour-list__result">
    <div class="c-result w-100">
      <div class="result" id="result-content">
        <ResultNav @sort="sortList" />

        <template v-if="!getLoading">
          <template v-if="getFilteredResults.length">
            <div class="result__items">
              <ResultItem v-for="result in getFilteredResults" :key="result.tourId" :result="result" />
            </div>

            <!-- <Paginate /> -->
          </template>

          <div class="px--2 px-md--0" v-else>
            <NoResult />
          </div>
        </template>

        <div class="px--2 px-md--0" v-else>
          <Loading />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResultItem from "./ResultItem";
import ResultNav from "./ResultNav";
import Loading from "./Loading";
import NoResult from "./NoResult";
// import Paginate from "./Paginate.vue";
import packageSortMixin from "@/mixin/packageSortMixin";

export default {
  name: "Result",

  mixins: [packageSortMixin],

  components: {
    ResultItem,
    ResultNav,
    Loading,
    NoResult,
    // Paginate,
  },

  computed: {
    ...mapGetters(["getLoading", "getFilteredResults"]),
  }
};
</script>

<style lang="scss">
@import "../style/modules/_result.scss";
</style>
